import Keys from "./Keys";
var CryptoJS = require("crypto-js");

const SetLoginInfo = (data) => {
    var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), Keys).toString();
    localStorage.setItem('u', ciphertext);
}
export default SetLoginInfo